<template>
  <div id="header">
    <el-row ref="topNav" class="top-nav">
      <el-col class="top-nav-container-phone">
        <i
          class="el-icon-menu top-nav-container-phone-icon"
          @click="changeShowMenuType"
        />
        <!-- <el-image
          style="
            cursor: pointer;
            border-radius: 5px;
            width: 108px;
          "
          :src="require('@/assets/images/20yearsbanner.jpg')"
          alt="和顺堂12周年"
          @click="openVideo"
        /> -->
        <img
          v-if="setting.logo.value"
          :src="setting.logo.value"
          alt="和顺堂"
          ondragstart="return false;"
          class="no-blue-border"
          style="width: 208px;"
        >
        <i
          ref="showSearch"
          class="iconfont ico-sousuo top-nav-container-phone-icon"
          @click="showPhoneSearch = !showPhoneSearch"
        />
      </el-col>
      <el-col
        v-if="
          (innerWidthType === 'xs' && showPhoneSearch) ||
            (innerWidthType === 'sm' && showPhoneSearch)
        "
        ref="topNavContainerPhoneSearch"
        class="top-nav-container-phone-search"
      >
        <!-- <div class="top-nav-container-phone-logo">
          <img
            v-if="setting.logo.value"
            :src="setting.logo.value"
            alt="和顺堂"
            ondragstart="return false"
            class="no-blue-border"
          >
        </div> -->
        <el-autocomplete
          v-model="state"
          size="small"
          :fetch-suggestions="querySearchAsync"
          class="search-input"
          @select="handleSelect"
        >
          <i
            slot="suffix"
            class="el-input__icon search-icon iconfont ico-sousuo"
          />
        </el-autocomplete>
      </el-col>
      <el-col
        v-if="
          (innerWidthType !== 'xs' && innerWidthType !== 'sm') ||
            (innerWidthType === 'xs' && showMenu) ||
            (innerWidthType === 'sm' && showMenu)
        "
        class="top-nav-container"
      >
        <el-menu
          class="el-menu-container"
          :mode="
            elMenuMode.indexOf(innerWidthType) !== -1
              ? 'vertical'
              : 'horizontal'
          "
          :menu-trigger="
            elMenuTrigger.indexOf(innerWidthType) !== -1 ? 'hover' : 'click'
          "
          :default-active="$route.path"
          unique-opened
          router
          @select="handleMenuSelect"
        >
          <img
            v-if="setting.logo.value"
            :src="setting.logo.value"
            alt="和顺堂"
            ondragstart="return false;"
            class="no-blue-border"
          >

          <div v-for="(item, index) in topNavDataTree" :key="index">
            <el-submenu
              v-if="item.children"
              :index="String(item.id)"
              :popper-class="
                item.children.length > 5
                  ? 'top-nav-popper'
                  : 'top-nav-popper-comm'
              "
              :show-timeout="30"
              :hide-timeout="30"
            >
              <template slot="title">{{ item.cat_name }}</template>
              <el-menu-item
                v-for="(chItem, chIndex) in item.children"
                :key="chIndex"
                :index="
                  `/${routeType[item.id]}/${chItem.parent_id}/${chItem.id}`
                "
                class="top-nav-popper-item"
              >
                <a
                  v-if="chItem.id === 13"
                  href="https://rbs.wellsoon.cn"
                  target="_blank"
                >{{ chItem.cat_name }}</a>
                <span v-else>{{ chItem.cat_name }}</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item
              v-else
              :index="
                onlyType[item.id]
                  ? `/${onlyType[item.id]}`
                  : `/${routeType[item.id]}/${chItem.parent_id}/${chItem.id}`
              "
            >{{ item.cat_name }}</el-menu-item>
          </div>

          <!-- <div>
            <el-menu-item
              style="background: transparent !important"
              index="/chargeMode"
            >收费栏目</el-menu-item>
          </div> -->

          <el-autocomplete
            v-model="state"
            size="small"
            :fetch-suggestions="querySearchAsync"
            class="search-input"
            @select="handleSelect"
          >
            <i
              slot="suffix"
              class="el-input__icon search-icon iconfont ico-sousuo"
            />
          </el-autocomplete>
        </el-menu>
      </el-col>
    </el-row>

    <videoDialog ref="videoDialog" />
  </div>
</template>

<script>
import API from '@/api/service'
import videoDialog from '../components/videoDialog.vue'
import { transformationalTreeData } from '@/utils'

export default {
  name: 'Header',
  components: {
    videoDialog
  },
  data() {
    return {
      innerWidthType: 'xs',
      topNavData: [],
      topNavDataTree: [],
      showMenu: false,
      showPhoneSearch: false,
      onlyType: {
        1: 'home',
        32: 'storeInformation',
        34: 'hkWellsoon'
      },
      routeType: {
        2: 'article',
        3: 'pharmacopoeia',
        4: 'aboutUs',
        5: 'news',
        32: 'storeInformation',
        34: 'hkWellsoon'
      },
      article: [],
      state: '',
      timeout: null,
      setting: null,
      elMenuMode: ['sm', 'xs'],
      elMenuTrigger: ['xl', 'lg']
    }
  },
  watch: {
    $route(newVal, oldVal) {
      this.showPhoneSearch = false
      if (newVal.name === 'home') {
        // this.changeShowPhoneSearch()
        this.$nextTick(() => {
          if (
            (this.innerWidthType === 'xs' && this.$refs.showSearch) ||
            (this.innerWidthType === 'sm' && this.$refs.showSearch)
          ) {
            this.$refs.showSearch.click()
          }
        })
      }
    },
    showPhoneSearch(newVal) {
      if (
        (this.innerWidthType === 'xs' && newVal) ||
        (this.innerWidthType === 'sm' && newVal)
      ) {
        this.$nextTick(() => {
          const phoneSearch = this.$refs.topNavContainerPhoneSearch.$el
          this.$parent.setPhoneSearchHeight(phoneSearch.clientHeight)
        })
      } else {
        this.$parent.setPhoneSearchHeight(0)
      }
    },
    innerWidthType(newVal) {
      if (
        (newVal === 'xs' && this.showPhoneSearch) ||
        (newVal === 'sm' && this.showPhoneSearch)
      ) {
        this.$nextTick(() => {
          const phoneSearch = this.$refs.topNavContainerPhoneSearch.$el
          this.$parent.setPhoneSearchHeight(phoneSearch.clientHeight)
        })
      } else {
        this.$parent.setPhoneSearchHeight(0)
      }
    }
  },
  beforeMount() {
    this.setting = this.$getLoc({ key: 'setting', json: 1 })
  },
  mounted() {
    this.getInnerWidthType()
    this.getTopNavData()
    window.addEventListener('resize', () => {
      this.getInnerWidthType()
    })
    this.getArticle()
    if (
      (this.innerWidthType === 'xs' && this.$route.name === 'home') ||
      (this.innerWidthType === 'sm' && this.$route.name === 'home')
    ) {
      this.showPhoneSearch = true
    }
  },
  destroyed() {
    window.removeEventListener('resize', () => {
      this.getInnerWidthType()
    })
  },
  methods: {
    getInnerWidthType() {
      if (window.innerWidth >= 1920) {
        this.innerWidthType = 'xl'
      } else if (window.innerWidth >= 1200) {
        this.innerWidthType = 'lg'
      } else if (window.innerWidth >= 992) {
        this.innerWidthType = 'md'
      } else if (window.innerWidth > 768) {
        this.innerWidthType = 'sm'
      } else {
        this.innerWidthType = 'xs'
      }
    },
    changeShowPhoneSearch() {
      this.showPhoneSearch = !this.showPhoneSearch
    },
    getTopNavData() {
      API.getArticleCat().then(res => {
        this.topNavData = res.data
        this.topNavDataTree = transformationalTreeData(res.data)
      })
    },
    getArticle() {
      API.getAllArticle().then(res => {
        this.article = res.data
      })
    },
    handleMenuSelect(key, keyPath) {
      this.showMenu = false
      this.$parent.getHeightList()
    },
    changeShowMenuType() {
      this.showMenu = !this.showMenu
    },
    querySearchAsync(queryString, cb) {
      var restaurants = this.article
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants

      // clearTimeout(this.timeout)
      // this.timeout = setTimeout(() => {
      cb(results)
      // }, 3000 * Math.random())
    },
    createStateFilter(queryString) {
      return state => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1
        )
      }
    },
    handleSelect(data) {
      this.state = ''
      const routeData = this.topNavData.filter(
        item => item.id === data.article_cat_id
      )[0]
      this.$router.push({
        name: this.routeType[Number(routeData.parent_id)],
        params: {
          parent_id: Number(routeData.parent_id),
          id: Number(routeData.id)
        },
        query: { id: data.id }
      })
    },
    openVideo() {
      this.$refs.videoDialog.open()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/header/xl.scss";
@media screen and (max-width: 1200px) {
  @import "@/assets/css/header/md.scss";
}
@media screen and (max-width: 992px) {
  @import "@/assets/css/header/sm.scss";
}
</style>



// WEBPACK FOOTER //
// src/view/common/header.vue